import { render, staticRenderFns } from "./SendEgiftPanelReviewSummary.vue?vue&type=template&id=2dc805ca&scoped=true"
import script from "./SendEgiftPanelReviewSummary.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelReviewSummary.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelReviewSummary.vue?vue&type=style&index=0&id=2dc805ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc805ca",
  null
  
)

export default component.exports